const ProgressBarStore = {
  data: {
    loading: false,
    timeoutHandle: null
  },

  methods: {
    setLoadingTimer (n = 500) {
      if (!ProgressBarStore.data.loading) {
        ProgressBarStore.data.timeoutHandle = setTimeout(ProgressBarStore.methods.setLoading, n);
      }
    },

    cancelLoadingTimer () {
      clearTimeout(ProgressBarStore.data.timeoutHandle);
      ProgressBarStore.methods.setNotLoading();
    },

    setLoading () {
      ProgressBarStore.data.loading = true;
    },

    setNotLoading () {
      ProgressBarStore.data.loading = false;
    }
  }
};

export default ProgressBarStore;
